const UploadLoadingIcon = ({ ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg xmlns="http://www.w3.org/2000/svg" width="37.207" height="26.576" viewBox="0 0 37.207 26.576" {...props}>
    <path
      fill="#ebebeb"
      d="M20.6 7a11.785 11.785 0 0 0-8.762 4.069 4.347 4.347 0 0 0-.54-.083A5.332 5.332 0 0 0 5.986 16.3 7.841 7.841 0 0 0 2 22.946a8 8 0 0 0 7.973 7.973h6.644v-2.658H9.973A5.319 5.319 0 0 1 7.9 18.046l.914-.374-.125-1c-.026-.218-.042-.343-.042-.374a2.636 2.636 0 0 1 2.653-2.654 2.576 2.576 0 0 1 .623.083l.831.208.5-.664a9.29 9.29 0 0 1 16.361 3.405l.249 1.038 1.121-.042c.28-.016.343-.042.249-.042a5.315 5.315 0 0 1 0 10.63H24.59v2.658h6.644a7.918 7.918 0 0 0 .54-15.821A11.868 11.868 0 0 0 20.6 7zm0 10.63l-5.315 5.315h3.986v10.63h2.658V22.946h3.986z"
      transform="translate(-2 -7)"
    />
    <path
      fill="#e2001a"
      d="M24.107 20.586l-5.124 5.3h3.843v10.6h2.562v-10.6h3.842z"
      transform="translate(-5.503 -9.916)"
    />
  </svg>
);

export default UploadLoadingIcon;
